import { render, staticRenderFns } from "./RequestReturnGoodsHead.vue?vue&type=template&id=6484c194&scoped=true"
import script from "./RequestReturnGoodsHead.vue?vue&type=script&lang=js"
export * from "./RequestReturnGoodsHead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6484c194",
  null
  
)

export default component.exports